<template>
  <span class="pos-rel">
    <a
      :href="`#popover-${_uid}`"
      @click.prevent="togglePopopver">
      <slot name="default"></slot>
    </a>
    <div
      :id="`popover-${_uid}`"
      :class="{ 'active': showPopopver }"
      class="popover top">
      <div class="arrow"></div>
      <div class="popover-content">
        <p>{{ text }}</p>
      </div>
    </div>
    <div
      @click.prevent="togglePopopver"
      v-if="showPopopver"
      class="popover-item-mask"></div>
  </span>
</template>

<script>
export default {
  props: [
    'text'
  ],
  data () {
    return {
      showPopopver: false
    }
  },
  mounted () {
    this.handleProsition()
  },
  methods: {
    togglePopopver () {
      this.showPopopver = !this.showPopopver
      this.handleProsition()
    },
    handleProsition () {
      const popoverProps = this.$el.querySelector(`#popover-${this._uid}`).getBoundingClientRect()
      const top = 0 - (popoverProps.height + 4)
      const left = 0 - (popoverProps.width / 2) + 5
      this.$el.querySelector(`#popover-${this._uid}`)
        .setAttribute('style', `top: ${top}px; left: ${left}px;`)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/components/ui/PopoverItem';
</style>
